import { html as o } from "@microsoft/fast-element";
const s = (i) => {
  const t = o.partial(i.prefix);
  return o`
    <div class="control" part="control">
      <${t}-icon class="hint-icon" name="${(n) => n.iconName}">
      </${t}-icon>
      <div class="hint-content">
        <slot class="hint-slot"></slot>
      </div>
    </div>
  `;
};
export {
  s as hintTemplate
};
